import React from 'react';
import styles from './DTCHeader.module.css';
import { ReactComponent as Washer } from '../../../assets/images/washer.svg';
import { ReactComponent as Electric } from '../../../assets/images/electrical.svg';
import { ReactComponent as Plumbing } from '../../../assets/images/plumbing.svg';
import { ReactComponent as Utilities } from '../../../assets/images/external-water.svg';
import { ReactComponent as HVAC } from '../../../assets/images/hvac.svg';
import cn from 'classnames';

const CategoryStepIcon = ({ active, category }) => {
    const getIcon = () => {
        switch (category.id) {
            case 'appliances':
                return <Washer className={styles.icon} />;
            case 'electrical':
                return <Electric className={styles.icon} />;
            case 'hvac':
                return <HVAC className={styles.icon} />;
            case 'utilities':
                return <Utilities className={styles.icon} />;
            case 'plumbing':
                return <Plumbing className={styles.icon} />;
            default:
                return null;
        }
    };

    return <div className={cn(styles.iconWrapper, active && styles.active)}>{getIcon()}</div>;
};

export default CategoryStepIcon;
